import $ from 'cash-dom';

const DeviceSizes = {
	'screen-xs-min': 480,
	'screen-xs-max': 767 - 1,
	'screen-sm-min': 767,
	'screen-sm-max': 992 - 1,
	'screen-md-min': 992,
	'screen-md-max': 1200 - 1,
	'screen-lg-min': 1200
};

const Device = {
	'screen-xs-min': 480,
	'screen-xs-max': 767 - 1,
	'screen-sm-min': 767,
	'screen-sm-max': 992 - 1,
	'screen-md-min': 992,
	'screen-md-max': 1200 - 1,
	'screen-lg-min': 1200,
	'breakpointMap': {
		'mobile': {'max': DeviceSizes['screen-xs-max']},
		'mobile-xs': {'max': DeviceSizes['screen-xs-min']},
		'non-mobile': {'min': DeviceSizes['screen-sm-min']},
		'tablet': {'max': DeviceSizes['screen-sm-max']},
		'tablet-landscape': {'max': DeviceSizes['screen-md-max']},
		'screen': {'min': DeviceSizes['screen-md-min']},
		'big-screen': {'min': DeviceSizes['screen-lg-min']}
	},
	breakpoint: function (point) {
		var map = this.breakpointMap[point];
		if (map) {
			if (window.matchMedia) {
				var queries = [];
				if (map.min) {
					queries.push('(min-width: ' + map.min + 'px)');
				}
				if (map.max) {
					queries.push('(max-width: ' + map.max + 'px)');
				}
				return window.matchMedia(queries.join(' and ')).matches;
			} else {
				if (map.min) {
					if ($(window).width() < map.min) {
						return false;
					}
				}
				if (map.max) {
					if ($(window).width() > map.max) {
						return false;
					}
				}
				return true;
			}
		}
	},
	isDesktopWidth: function () {
		return (window.innerWidth || $(window).width()) >= 1200;
	},
	isMobile: function () {
		return this.breakpoint('mobile');
	},
	isMobileXS: function () {
		return this.breakpoint('mobile-xs');
	},
	isTablet: function () {
		if (this.isDesktopWidth()) {
			return false;
		}
		return this.breakpoint('tablet') || this.isIPad() || this.isAndroidTablet();
	},
	isIPad: function () {
		if (this.isDesktopWidth()) {
			return false;
		}
		return (
			/iPad/.test(navigator.userAgent) ||
			(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ||
			(navigator.userAgent.includes('Macintosh') && navigator.maxTouchPoints > 1)
		);
	},
	isAndroidTablet: function () {
		if (this.isDesktopWidth()) {
			return false;
		}
		return /Android/i.test(navigator.userAgent) && !/Mobile/i.test(navigator.userAgent);
	},
	isTabletLandscape: function () {
		if (this.isDesktopWidth()) {
			return false;
		}
		return this.breakpoint('tablet-landscape') || this.isIPad() || this.isAndroidTablet();
	},
	isScreen: function () {
		return this.breakpoint('screen');
	},
	isBigScreen: function () {
		return this.breakpoint('big-screen');
	},
	isTouch: function () {
		try {
			if (navigator && (navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0)) {
				return true;
			}
		} catch (e) {
			console.log('Error detecting touch support', e);
		}

		if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
			return true;
		}

		var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

		var mq = function (query) {
			return window.matchMedia(query).matches;
		};

		if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0) || (window.DocumentTouch && document instanceof DocumentTouch)) {
			return true;
		}

		// include the 'heartz' as a way to have a non matching MQ to help terminate the join
		// https://git.io/vznFH
		var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
		return mq(query);
	},

	isGPSI: function () {
		return navigator.userAgent.indexOf('Speed Insights') !== -1 || navigator.userAgent.indexOf('Lighthouse') !== -1;
	},

	isTrueMobile: function () {
		if (this.isDesktopWidth()) {
			return false;
		}

		if (this.isMobile() || this.isTablet() || this.isTabletLandscape()) {
			return true;
		}

		// Safari on iPad can report a desktop-width viewport; coarse pointer / no hover
		// is the same signal the market project uses for touch-only devices.
		if (window.matchMedia) {
			const hasCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
			const cannotHover = window.matchMedia('(hover: none)').matches;

			if (hasCoarsePointer && cannotHover) {
				return true;
			}
		}

		return this.isTouch();
	},

	resolveExitDevice: function () {
		if (this.isDesktopWidth()) {
			return 'desktop';
		}
		if (this.isIPad() || this.isAndroidTablet()) {
			return 'tablet';
		}
		if (this.isMobile()) {
			return 'mobile';
		}
		if (this.isTablet() || this.isTabletLandscape()) {
			return 'tablet';
		}
		if (this.isTrueMobile()) {
			return 'tablet';
		}

		return 'desktop';
	}
};

if (typeof window !== 'undefined') {
	window.Device = Device;
}

export default Device;
